import { DayKey, PaymentMethod, TimeSlot } from './types';

export const emptySchedule: Record<DayKey, TimeSlot[]> = {
  monday: [],
  tuesday: [],
  wednesday: [],
  thursday: [],
  friday: [],
  saturday: [],
  sunday: []
};

export const DEFAULT_INSTRUCTIONS = {
  [PaymentMethod.TRANSFER]: {
    Argentina: `<p>Para pagos mediante transferencia:</br>
         Transferir al alias: <span style="color: #0072FB;">EJ.ALIAS</span></br>
         CBU: <span style="color: #0072FB;">xxxxxxxxxx</span></br>
         Luego de realizar la transferencia, enviar el comprobante a nuestro WhatsApp: <span style="color: #0072FB;">xxxxxxxxxx</span></p>`,
    Uruguay: `<p>Para pagos mediante transferencia:</br>
         Transferir a la cuenta #: <span style="color: #0072FB;">xxxxxxxxxx</span></br>
         Luego de realizar la transferencia, enviar el comprobante a nuestro WhatsApp: <span style="color: #0072FB;">xxxxxxxxxx</span></p>`,
    Chile: `<p>Para realizar el pago mediante transferencia bancaria:</br>
         1. Realizar tu transferencia a:</br>
         <ul>
           <li>Banco: <span style="color: #0072FB;">[nombre del banco]</span></li>
           <li>Tipo de cuenta: <span style="color: #0072FB;">[tipo]</span></li>
           <li>RUT: <span style="color: #0072FB;">[número]</span></li>
           <li>Número de cuenta: <span style="color: #0072FB;">[número]</span></li>
         </ul></br>
         2. Enviar el comprobante</p>`
  },
  [PaymentMethod.CASH]: {
    Argentina: `<p>1. El pago se realiza antes / después de realizar el servicio</br>
         2. Por favor traer el monto exacto</p>`,
    Uruguay: `<br>1. El pago se realiza antes / después de realizar el servicio</br>
         2. Por favor traer el monto exacto</p>`,
    Chile: `<br>1. El pago se realiza antes / después de realizar el servicio</br>
         2. Por favor traer el monto exacto</p>`
  }
};
